<template>
  <div class="absolute inset-0 z-10 flex items-center justify-end pr-6">
    <span
      :class="pnl > 0 ? 'bg-ontick-green-600' : 'bg-ontick-red-600'"
      class="clip absolute inset-0 flex items-center justify-center overflow-hidden"
    >
      <img
        v-if="pnl > 0"
        src="/img/arrow-up.png"
        class="arrow-up absolute top-0 right-0"
        alt=""
      />
      <img
        v-else
        src="/img/arrow-down.png"
        class="arrow-down absolute top-0 right-0"
        alt=""
      />
    </span>
    <!-- <i
      v-html="$icons.best_call_long"
      class="arrow-up absolute top-0 right-[300px] opacity-25"
    ></i> -->
    <span
      class="text-shadow pnl relative z-10 text-2xl font-bold lg:text-4xl"
      :class="pnl > 0 ? 'text-[#023922]' : 'text-[#4E1212]'"
    >
      {{ pnl | currency }}
    </span>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    pnl: {
      type: Number,
    },
    bo_id: {
      type: Number,
    },
  },

  methods: {
    ...mapActions({ removeBest: "bests/removeBest" }),
  },

  mounted() {
    setTimeout(() => {
      this.removeBest(this.bo_id);
    }, 4000);
  },
};
</script>

<style lang="scss" scoped>
.text-shadow {
  text-shadow: 1px 2px 2px rgba(0, 0, 0, 0.25);
}

@keyframes text-in {
  from {
    transform: translateX(-100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes text-out {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}

.pnl {
  opacity: 0;
  animation: text-in 0.5s ease-out 0.5s 1 normal forwards,
    text-out 0.5s ease-out 3s 1 normal forwards;
}

@keyframes in {
  from {
    transform: translateX(-100%) skewX(-15deg) scale(105%);
    opacity: 0;
  }
  to {
    transform: translateX(0) skewX(-15deg) scale(105%);
    opacity: 1;
  }
}

@keyframes out {
  from {
    transform: translateX(0) skewX(-15deg) scale(105%);
    opacity: 1;
  }
  to {
    transform: translateX(100%) skewX(-15deg) scale(105%);
    opacity: 0;
  }
}

.clip {
  animation: in 0.5s ease-in 0s 1 normal forwards,
    out 0.5s ease-in 3s 1 normal forwards;
  // transform: scale(105%);
}

.clip {
  transform: skewX(-15deg) scale(105%);
}

@keyframes arrow-up {
  from {
    transform: translate(-15%, 0%) scale(150%);
  }
  to {
    transform: translate(-15%, -100%) scale(150%);
  }
}

.arrow-up {
  animation: arrow-up 5s linear 0s 1 normal forwards;
}

@keyframes arrow-down {
  from {
    transform: translate(-15%, -100%) scale(150%);
  }
  to {
    transform: translate(-15%, 0%) scale(150%);
  }
}

.arrow-down {
  animation: arrow-down 5s linear 0s 1 normal forwards;
}
</style>
